export const sort = [
  { label: "Lok.", name: "id", sortable: false },
  { label: "Nazwa", name: "name", sortable: false },
  { label: "Typ", name: "type", sortable: false },
  { label: "Unikalność", name: "is_variation_uniqueness_enabled", sortable: false },
  
];
